import _ from 'lodash';
import config from '@swiper/config';

// Eliminate sensitive stuff from the config that we don't need to
// have in server memory
[
  'provisioning',
  'importer',
].forEach( x => delete config.data[ x ] );

export default config;
